import mapping from 'tempcontrol/data/thermostatic-digital-map.json';

export interface ThermostaticDigitalMapEntry {
  thermostaticSku: string;
  productName: string;
  digitalSku: string;
  readyForWebsite: boolean;
  active: boolean;
  tier: string;
}

const thermostaticMap = mapping as Record<string, ThermostaticDigitalMapEntry>;

const mapKeysByLength = Object.keys(thermostaticMap).sort((a, b) => b.length - a.length);

/** Strip a manifold prefix such as `[3] 7-1000`. */
export const stripManifoldPrefix = (partNumber: string): string => partNumber.replace(/^\[\d+\]\s*/, '').trim();

/**
 * Resolve a calculated part number to the closest thermostatic catalog key
 * in the conventional ↔ digital mapping spreadsheet.
 */
export const resolveThermostaticMapKey = (partNumber: string, valveSeries?: string | null): string | null => {
  const bare = stripManifoldPrefix(partNumber);

  if (thermostaticMap[bare]) {
    return bare;
  }

  for (const key of mapKeysByLength) {
    if (bare === key) {
      return key;
    }
    if (bare.startsWith(`${key}-`) || bare.startsWith(`${key}B`) || bare.startsWith(`${key}A`)) {
      return key;
    }
  }

  if (valveSeries && thermostaticMap[valveSeries]) {
    return valveSeries;
  }

  return null;
};

export const getDigitalSkuForThermostatic = (thermostaticKey: string): string | null => {
  const entry = thermostaticMap[thermostaticKey];
  return entry?.digitalSku?.trim() || null;
};

export const getMapEntry = (thermostaticKey: string): ThermostaticDigitalMapEntry | null =>
  thermostaticMap[thermostaticKey] ?? null;
